module.exports = __webpack_public_path__ + "media/images/lp/history3-pc-ec4aba1380be76040a4df6808ec68f65.jpg";